import script from "./popup-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./popup-error.vue?vue&type=script&lang=ts&setup=true"

import "./popup-error.vue?vue&type=style&index=0&id=b851980c&lang=scss&scoped=true"

import exportComponent from "/Users/tuanphung/work/beansmile/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b851980c"]])

export default __exports__